module.exports = __webpack_public_path__ + "static/media/sale.e67b0288.svg";